"use client";

import { useAppSelector } from "@/src/store/hooks";
import { useWishlistOperations } from "../components/WishlistSyncProvider";

export function useWishlist() {
  const operations = useWishlistOperations();
  const { data: wishlist, variantIds, count } = useAppSelector((state) => state.wishlist);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  return {
    ...operations, wishlist, variantIds, count, isAuthenticated,
    isMutating: operations.pendingVariantId !== null,
    isInWishlist: (variantId: number | null) => typeof variantId === "number" && variantIds.includes(variantId),
  };
}
